export default __webpack_public_path__ + "static/media/511.98687779.jpg";